import CommonApi from "../api/commonApi";

export async function fileDownload(serverFileName, originFileName) {
  try {
    const data = {
      serverFileName: serverFileName,
      originalFileName: originFileName,
    };
    const response = await CommonApi.Download(data);
    download(response, originFileName);
  } catch (error) {
    console.log(error);
  }
}

function download(response, filename) {
  const url = window.URL.createObjectURL(
    new Blob([response.data], {
      type: response.headers["content-type"],
    })
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${filename}`);
  link.style.cssText = "display:none";
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export function convertFileSize(filesize) {
  var text = ["bytes", "kB", "MB", "GB", "TB", "PB"];
  var e = Math.floor(Math.log(filesize) / Math.log(1024));
  return (filesize / Math.pow(1024, e)).toFixed(2) + " " + text[e];
}
